const common = {
  'nav.home': 'Home',
  'nav.guide': 'Shopping Guide',
  'nav.categories': 'Categories',
  'nav.visitMain': 'Visit Main Website',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.es': 'Español',
  'lang.pl': 'Polski',

  'category.shoes': 'Shoes',
  'category.hoodies': 'Hoodies & Sweaters',
  'category.tshirts': 'T-Shirts',
  'category.jackets': 'Jackets',
  'category.pants': 'Pants & Shorts',
  'category.headwear': 'Headwear',
  'category.sets': 'Sets',
  'category.underwear': 'Underwear & Underpants',
  'category.jersey': 'Jersey',
  'category.accessories': 'Accessories',
  'category.bags': 'Bags',
  'category.belts': 'Belts',
  'category.perfumes': 'Perfumes',
  'category.other': 'Other Stuff',

  'footer.tagline': 'An independent USFans resource hub.',
  'footer.quickLinks': 'Quick Links',
  'footer.categoriesTitle': 'Categories',
  'footer.legal': 'Legal',
  'footer.disclaimerTitle': 'Disclaimer',
  'footer.disclaimerText': 'USFansLink is an independent informational resource. We do not guarantee the accuracy, safety or legitimacy of every third-party seller, link, spreadsheet entry, coupon or discount code. Always verify information independently.',
  'footer.rights': 'All rights reserved.',
};

export default common;